module.exports = __webpack_public_path__ + "static/media/main_large_4.fe7b758d.png";